import { LOADING } from "../../../constants/constant";
import {
    DELETE_DOCS_SUCCESS,
    DELETE_DOCS_FAILED,
    DELETE_DOCS,
    DELETE_DOCS_RESET,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: undefined,
};

export default function deleteDocsReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case DELETE_DOCS:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case DELETE_DOCS_SUCCESS:
      let userRes = Object.assign({}, state);
      userRes.status = action.data.status_message;
      userRes.isLoading = false;
      userRes.statusCode = action.data.status_code;

      if (userRes.statusCode === 10) {
        userRes.error = false;
      } else {
        userRes.error = true;
        userRes.errorMessage = action.data.message;
      }
      return userRes;

    case DELETE_DOCS_FAILED:
      return Object.assign({}, state, action.error);
    
      case DELETE_DOCS_RESET:
      return initialState

    default:
      return state;
  }
}
